import { GoogleCallback } from "@homebound/auth-components";
import { RouteObject } from "react-router-dom";
import { SignIn } from "src/routes/auth/SignIn";
import { GuestShell } from "src/routing/components/GuestShell";
import { googleCallbackRoute, signInRoute } from "src/routing/domains/authPaths";

/**
 * Guest-only auth route tree (`/signIn`, `/auth/gcallback`).
 *
 * Role: data router domain route.
 *
 * Stack: `GuestShell` → page. These URLs must not sit under `AppShell`, which redirects
 * unauthenticated users to `/signIn`.
 *
 * Path constants live in `authPaths.ts`.
 */
export const authRoutes: RouteObject[] = [
  {
    Component: GuestShell,
    children: [
      { path: signInRoute.path, Component: SignIn },
      { path: googleCallbackRoute.path, Component: GoogleCallback },
    ],
  },
];
